/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TmoButton } from '@support/shared/widgets/interfaces/button.interface';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'tmo-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnDestroy {
  /**
   *  CTA component
   *  Interface which is used  TmoButton. which has 4 properties.
   *  id - string - button id
   *  name - string - button name
   *  type - string - back/other
   *  class - string - primary/secondary/tertiary
   */
  @Input() public button: TmoButton;
  /**
   * Boolean input property to disable/enable the button.
   */
  @Input() public disabled: boolean;

  /**
   * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
   * take precedence so this may be omitted.
   */
  /* tslint:disable:no-input-rename */
  @Input('aria-label') public ariaLabel?: string;

  /** Event emitted when button is clicked
   * It emits the 'Event' object.
   */
  @Output() public onSelect: EventEmitter<MouseEvent>;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ariaLabel = '';
    this.onSelect = new EventEmitter();
  }

  /**
   * Called whenever a CTA is clicked
   * @param event - Event object
   * Emits an event with 'event' object as data.
   */

  public onClick(event: MouseEvent): void {
    if (this.button && this.button.type === 'back') {
      this.router.navigate(['../'], { relativeTo: this.route });
    } else {
      this.onSelect.emit(event);
    }
  }

  public ngOnDestroy(): void {}
}
